import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import helperNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import helpersTime from "../../../../../helpers/time";
import TypeGroupSitePublisher from "./../../TypeGroupSitePublisher";
import httpService from "../../../../../services/httpServices/httpServices";
import Pagination from "../../../../partials/content/Pagination";

export default function AllCategorySitePublisher() {
  const [showSelect, setShowSelect] = useState(false);
  const [link, setLink] = useState();

  const [groupUserSitePublisher, setGroupUserSitePublisher] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [
    groupUserSitePublisherIDSearchFilter,
    setGroupUserSitePublisherIDSearchFilter,
  ] = useState();

  useEffect(() => {
    getGroupUserSitePublisher();
  }, []);

  useEffect(() => {
    getGroupUserSitePublisher();
  }, [currentPage, countItemPerPage, groupUserSitePublisherIDSearchFilter]);

  const getGroupUserSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const groupUserSitePublisher = await sendRequestGetGroupUserSitePublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!groupUserSitePublisher) {
      return;
    }

    setGroupUserSitePublisher(
      groupUserSitePublisher.category_user_site_publishers
    );
    setCountPage(groupUserSitePublisher.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (groupUserSitePublisherIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${groupUserSitePublisherIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generateTagGroupUserSitePublisher = () => {
    return (
      <>
        <div className="py-2 w-50">
          <div className="pl-2">
            <label>جستجو در شماره گروه نمایش دهنده</label>
          </div>
          <div>
            <input
              onKeyUp={(e) =>
                setGroupUserSitePublisherIDSearchFilter(e.target.value)
              }
              onWheel={(event) => event.currentTarget.blur()}
              className="form-control"
              id="site"
              type="number"
            />
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>عنوان</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {groupUserSitePublisher.map((group, index) => {
                return (
                  <tr key={index}>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{helperNumber.toPersianNum(group.cau_id)}</td>
                    <td>{group.cau_name}</td>
                    <td>
                      {helperNumber.toPersianNum(
                        group.cau_created_at.split(" ")[0] +
                          " " +
                          group.cau_created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <Link
                        to={`/manage/category-user-site-publishers/${group.cau_id}`}
                        className="btn btn-success"
                      >
                        <i className="fa fa-edit"></i>
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const sendRequestGetGroupUserSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/category-user-site-publishers/alternative/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-type-category-user-site-publishers-alternative"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  همه گروه نمایش دهنده بنری جایگزین
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="pb-2 d-flex">
                <div
                  className="btn btn-success ml-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSelect((prevState) => !prevState);
                  }}
                >
                  <span>
                    <span>اضافه کردن گروه جدید </span>
                  </span>
                </div>
                <div className="ml-2 d-inline ">
                  <select
                    className={`form-control ${showSelect ? "" : "d-none"}`}
                    onChange={(e) => {
                      setLink(e.target.value);
                    }}
                  >
                    <option value="">
                      نحوه ساخت گروه نمایش دهنده خود را انتخاب کنید
                    </option>
                    <option value="/manage/publishers/add-category-site-publisher-alternative-via-select-positions">
                      انتخاب جایگاه سایت های نمایش دهنده
                    </option>
                    <option value="/manage/publishers/add-category-site-publisher-alternative-via-select-web-site-publisher">
                      انتخاب سایت های نمایش دهنده
                    </option>
                    <option value="/manage/publishers/add-category-site-publisher-alternative-via-category-subject">
                      انتخاب دسته های موضوعی سایت های نمایش دهنده
                    </option>
                  </select>
                </div>
                <Link
                  className={`btn btn-info ${link ? "" : "d-none"}`}
                  to={link}
                >
                  <span>
                    <i className="fa fa-plus"></i>
                  </span>
                  <span className="pr-2">اضافه کردن</span>
                </Link>
              </div>

              {groupUserSitePublisher.length == 0 &&
              groupUserSitePublisherIDSearchFilter == null ? (
                <></>
              ) : (
                generateTagGroupUserSitePublisher()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
